import React from "react";
import { aboutData } from "../data/mock";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";

export const AboutSection = () => {
  return (
    <section id="about" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Column */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-emerald-900/10">
              <img
                src={aboutData.image}
                alt="AM Scrap Dealers facility"
                className="w-full h-[400px] md:h-[480px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/40 to-transparent" />
            </div>
            {/* Floating stat card */}
            <div className="absolute -bottom-6 -right-4 md:right-6 bg-white rounded-2xl shadow-xl shadow-emerald-900/10 p-6 border border-emerald-100">
              <div className="text-3xl font-bold text-emerald-700">15+</div>
              <div className="text-sm text-slate-500 font-medium">Years of Experience</div>
            </div>
            {/* Decorative */}
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-emerald-100 rounded-2xl -z-10" />
          </div>

          {/* Content Column */}
          <div className="order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 bg-emerald-50 rounded-full px-4 py-1.5 mb-6">
              <div className="w-2 h-2 rounded-full bg-emerald-500" />
              <span className="text-emerald-700 text-sm font-semibold uppercase tracking-wider">
                About Us
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 leading-tight mb-4">
              {aboutData.subtitle}
            </h2>

            <p className="text-slate-500 text-lg leading-relaxed mb-8">
              {aboutData.description}
            </p>

            <div className="space-y-3.5 mb-10">
              {aboutData.highlights.map((item, i) => (
                <div key={i} className="flex items-center gap-3 group">
                  <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-200 transition-colors">
                    <CheckCircle2 className="w-4 h-4 text-emerald-700" />
                  </div>
                  <span className="text-slate-700 font-medium">{item}</span>
                </div>
              ))}
            </div>

            <Button
              className="bg-emerald-700 hover:bg-emerald-600 text-white rounded-xl px-6 py-5 text-base font-semibold shadow-lg shadow-emerald-700/15 hover:shadow-emerald-600/25 transition-all duration-300 hover:-translate-y-0.5"
              onClick={() => {
                const el = document.querySelector("#contact");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Get In Touch
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
